<div class="card overflow-hidden">
	<div class="card-body p-4 p-lg-5">
		<div class="row">
			<div class="col-12">
				<div class="text-center">
					<div class="mb-4">
						<i class="ri-spam-line text-danger" style="font-size: 4rem"></i>
					</div>
					<h5 class="text-primary mb-3">Access Not Authorized!</h5>
					<p class="text-muted mb-4">Sorry, you don't have the necessary permissions to access this page.</p>
					<div class="row justify-content-center">
						<div class="col-auto">
							<button type="button" class="btn btn-success" (click)="goBack()">
								<i class="ri-arrow-left-line me-1"></i>
								Back
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
